import SvgIcon from '@mui/material/SvgIcon';

export const GoalSunlightIcon = () => (
  <SvgIcon
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24 47.4C30.25 47.4 36.127 44.966 40.546 40.546C44.965 36.126 47.4 30.25 47.4 24C47.4 17.75 44.966 11.873 40.546 7.45398C36.126 3.03498 30.25 0.599976 24 0.599976C17.75 0.599976 11.873 3.03398 7.45398 7.45398C3.03498 11.874 0.599976 17.75 0.599976 24C0.599976 30.25 3.03398 36.127 7.45398 40.546C11.874 44.965 17.75 47.4 24 47.4Z"
      fill="#442EE0"
    />
    <path
      d="M22.2 19.046L10.788 35.344L9.80498 34.656L21.6 17.811V14.37L15.603 14.4H15.6C15.358 14.4 15.14 14.255 15.046 14.031C14.952 13.807 15.004 13.548 15.175 13.376L16.551 12L15.175 10.624C15.003 10.452 14.952 10.194 15.045 9.96998C15.138 9.74598 15.357 9.59998 15.599 9.59998H22.199C22.53 9.59998 22.799 9.86898 22.799 10.2V17.811L28.59 26.081L30.708 23.056C30.82 22.896 31.004 22.8 31.2 22.8C31.396 22.8 31.579 22.896 31.692 23.056L39.674 34.456C39.802 34.639 39.818 34.879 39.715 35.077C39.612 35.275 39.407 35.4 39.183 35.4H23.4V34.2H38.03L31.2 24.446L26.23 31.544C26.118 31.704 25.934 31.8 25.738 31.8H21.312L18.83 35.344L17.847 34.656L20.508 30.856C20.62 30.696 20.804 30.6 21 30.6H25.426L27.858 27.127L22.2 19.046ZM21.6 10.8H17.049L17.825 11.576C18.059 11.81 18.059 12.19 17.825 12.425L17.056 13.194L21.6 13.17V10.8Z"
      fill="#FEF04A"
    />
  </SvgIcon>
);
